export const NoPenaltyGuessingDescription = () => (
    <>
      <p>
        Points are never deducted for wrong answers. So, it's always better to
        guess than to leave an answer blank.
      </p>
    </>
  );
    
    export default NoPenaltyGuessingDescription;